/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */
import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

import { Wrapper } from './style';

const PercentageBar = ({
  statusPercentage,
  showPercentage,
  invertColors,
  threshold,
  limit_value,
}) => {
  const warningVal =
    ((limit_value - threshold.threshold_high) / limit_value) * 100;
  const dangerVal =
    ((limit_value - threshold.threshold_highest) / limit_value) * 100;
  const v1 = statusPercentage <= warningVal ? 'warning' : 'success';
  let variant = statusPercentage <= dangerVal ? 'danger' : v1;

  if (invertColors) {
    const v2 = statusPercentage <= dangerVal ? 'warning' : 'danger';
    variant = statusPercentage <= warningVal ? 'success' : v2;
  }

  return (
    <Wrapper $showPercentage={showPercentage}>
      <ProgressBar variant={variant} now={statusPercentage} />
      {showPercentage && `${statusPercentage}%`}
    </Wrapper>
  );
};

PercentageBar.defaultProps = {
  showPercentage: true,
  invertColors: false,
};

PercentageBar.propTypes = {
  statusPercentage: PropTypes.any.isRequired,
  showPercentage: PropTypes.bool,
  invertColors: PropTypes.bool,
  threshold: PropTypes.object.isRequired,
  limit_value: PropTypes.number.isRequired,
};

export default PercentageBar;
